// FILE: src/utils/activity.js
// One place that hears "the student is doing something" (B-16): DOM input,
// messages from the course iframe (the deck), and later SCORM commits
// (WP-4). The idle timer and the server keepalive both subscribe.
const listeners = new Set();

export function markActivity() {
  listeners.forEach((fn) => {
    try {
      fn();
    } catch {
      /* a listener's failure must not stop the others */
    }
  });
}

export function onActivity(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
